import { Dispatch, FC, SetStateAction, useState } from 'react';
import { Button } from 'reactstrap';
import { useAppDispatch } from '../../../app/hooks';
import { updateLicenseToPaid } from './slice';
import { Modal } from '../../../Components/Custom/modal';

export const MarkLicenseAsPaid: FC<{
  id: number;
  params: URLSearchParams;
}> = ({ id, params }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        size='sm'
        color='secondary'
        className='btn btn-soft-secondary btn-sm'
        outline
        onClick={() => setIsOpen(!isOpen)}>
        Mark as paid
      </Button>

      <MarkLicenseAsPaidModal
        id={id}
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        params={params}
      />
    </>
  );
};

export const MarkLicenseAsPaidModal: FC<{
  id: number;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  isOpen: boolean;
  params: URLSearchParams;
}> = ({ id, isOpen, params, setIsOpen }) => {
  const dispatch = useAppDispatch();

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={() => setIsOpen(!isOpen)}
      title='Mark as delivered'
      actions={
        <>
          <Button
            color='primary'
            outline
            onClick={() => setIsOpen(!isOpen)}
            className='m-1'>
            Cancel
          </Button>
          <Button
            color='primary'
            className='m-1'
            onClick={() => {
              setIsOpen(!isOpen);
              dispatch(updateLicenseToPaid({ id, params }));
            }}>
            Yes
          </Button>
        </>
      }>
      <div className='mb-3'>
        <div className='avatar-lg mx-auto'>
          <div className='avatar-title bg-light text-primary display-5 rounded-circle'>
            <i className='ri-error-warning-fill '></i>
          </div>
        </div>
      </div>
      <h2 className='text-center'>Are you sure?</h2>
      <p className='text-center'>You won’t be able to revert this!</p>
    </Modal>
  );
};
